var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4212 12.0094L17.7107 7.71421C18.1019 7.32161 18.1008 6.68621 17.7082 6.29498C17.3157 5.90376 16.6804 5.90487 16.2892 6.29746L12.0097 10.6026L7.71513 6.31242C7.32259 5.9212 6.68728 5.92231 6.29611 6.3149C5.90494 6.70749 5.90605 7.3429 6.29858 7.73412L10.6031 12.0143L6.31355 16.3094C6.1247 16.4974 6.01873 16.7531 6.0192 17.0196C6.01966 17.2861 6.12652 17.5413 6.31603 17.7287C6.504 17.9175 6.7596 18.0235 7.02606 18.0231C7.29251 18.0226 7.54774 17.9157 7.73505 17.7262L12.0146 13.4211L16.3091 17.7112C16.4971 17.9001 16.7527 18.0061 17.0192 18.0056C17.2856 18.0052 17.5409 17.8983 17.7282 17.7087C17.917 17.5207 18.023 17.2651 18.0225 16.9986C18.0221 16.7321 17.9152 16.4769 17.7257 16.2895L13.4212 12.0094Z",
    fill: "#2E2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.f7d1f7bafa413ba6d48f717b76b70777.svg";
export { ForwardRef as ReactComponent };